module.exports = __webpack_public_path__ + "static/media/จอ.46db991f.jpg";